let snd = "";
module.exports = snd;
